import { TemplateConfig } from '../../../template-config.interface';

export const disneyEspnRugbyUrbaMiniatura: TemplateConfig = {
  id: 'espn/espn-vs/rugby/urba-top-12/miniatura',
  clientId: 'DISNEY',
  title: 'Miniatura con escudos',
  description: 'Template ESPN deportivo en formato miniatura',
  aspectRatio: 'horizontal',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/URBA-Top-12-miniatura.jpeg',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/URBA-Top-12-miniatura.jpeg',

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2']
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1']
    }
  ],

  promptTemplate: `Haceme una "miniatura con escudos" URBA Top 12 entre los equipos "Newman" y "SIC"`
};
